import React from 'react'
import { useState,useEffect } from 'react'

import HelpFunctions from '../../../functions/dashboard/help'
import Add from './add'
import List from './list'

const Index = () => {
    const [Values,setValues] = useState([]);
    useEffect(()=>{
        HelpFunctions.Get(setValues)
    },[])

  return (
    <div className='admin_forms_main_container'>
      <div className='admin_forms_row'>
        <div className='admin_col_50'></div>
        <div className='admin_col_50'>
            <Add setValues={setValues}/>
        </div>
      </div>
      <List Values = {Values}/>
    </div>
  )
}

export default Index
